import { Observable } from 'rxjs';

export interface PusherEvent<T> {
  name: string;
  data: T;
  channel: string;
}
export interface SocketSubscription<T> {
  eventBus: Observable<PusherEvent<T>>;
  disconnect: () => void;
}

export enum SocketEvents {
  Connected = 'connected',
  Disconnected = 'disconnected',
}
